import { ChangeEvent } from "react";
import { Box } from "@mui/material";
import { AppTextField } from "src/Pages/components";
import { ModalFilterCore } from "src/Pages/components/ModalFilterCore/Index";

import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useHttpTableUsers } from "../table/Hooks/useHttpTableUsers";
import { IValuesFilterLeads } from "src/Contexts/Leads/LeadsTypes";
import { valuesDefaultFilterUsers } from "src/Contexts/Root/valuesDefaultInputsRoot/ValueDefaultInputRoot";
import { useContextRoot } from "src/Contexts/Root/RootContext";

export const FilterSidebar = () => {
  const { setValuesFilterLeads, valuesFilterLeads } = useContextRoot();

  const { setAttTable } = useConfigPageContext();

  const { handleGet } = useHttpTableUsers();

  const handleChange =
    (prop: keyof IValuesFilterLeads) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesFilterLeads({
        ...valuesFilterLeads,
        [prop]: event.target.value,
      });
    };

  const ClearFilter = async () => {
    setAttTable((item) => !item);
    setValuesFilterLeads(valuesDefaultFilterUsers);
  };

  const FilterSearch = async () => {
    await handleGet();
  };

  return (
    <ModalFilterCore FilterClear={ClearFilter} FilterSearch={FilterSearch}>
      <Box
        id="container leads"
        sx={{
          "& > .MuiAutocomplete-root, & > .MuiTextField-root": {
            flexWrap: "wrap",
            display: "flex",
            marginBottom: "1rem",
          },
        }}
      >
        <AppTextField
          label="Nome"
          fullWidth
          value={valuesFilterLeads.name}
          onChange={handleChange("name")}
        />
        {/* <AppTextField
          label="Nível de interesse"
          fullWidth
          select
          value={valuesFilterLeads.interestLevel}
          onChange={handleChange("interestLevel")}
        >
          <MenuItem value=" ">Todos</MenuItem>
          <MenuItem value="HIGH">Alto</MenuItem>
          <MenuItem value="MEDIUM">Médio</MenuItem>
          <MenuItem value="LOW">Baixo</MenuItem>
        </AppTextField> */}
      </Box>
    </ModalFilterCore>
  );
};
